import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';

import { toCategoryLink, toSubcategoryLink } from 'lib/links';

import SidebarBox from './SidebarBox';

const FEATURED_SUBCATEGORIES = [
  {
    name: 'Tvs',
    slug: toSubcategoryLink('tv'),
  },
  {
    name: 'Smartphones',
    slug: toCategoryLink('smartphones-tablets-e-telefones'),
  },
  {
    name: 'Notebook',
    slug: toSubcategoryLink('notebooks'),
  },
  {
    name: 'Geladeira',
    slug: toSubcategoryLink('geladeiras'),
  },
  {
    name: 'Fraldas',
    slug: toSubcategoryLink('fraldas'),
  },
  {
    name: 'Games',
    slug: toCategoryLink('games'),
  },
  {
    name: 'Iphone',
    slug: toSubcategoryLink('iphone'),
  },
  {
    name: 'Eletrodomésticos',
    slug: toCategoryLink('eletrodomesticos'),
  },
  {
    name: 'Cadeira Gamer',
    slug: toSubcategoryLink('cadeira-gamer'),
  },
  {
    name: 'Playstation 5',
    slug: toSubcategoryLink('playstation-5'),
  },
  {
    name: 'Notebook Gamer',
    slug: toSubcategoryLink('notebook-gamer'),
  },
];

const FeaturedSubcategories = ({ className }) => (
  <SidebarBox
    className={twMerge('pb-4', className)}
    title="Categorias em destaque"
  >
    <div className="mt-2 flex flex-wrap gap-2">
      {FEATURED_SUBCATEGORIES.map(({ name, slug }) => (
        <NextLink key={slug} href={slug} prefetch={false} passHref>
          <Button as="a" size="size3" type="primary-stroke">
            {name}
          </Button>
        </NextLink>
      ))}
    </div>
  </SidebarBox>
);

FeaturedSubcategories.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default FeaturedSubcategories;
